const mappingStreamType = [
  ['tv', ({ content_type }) => /tv_|m_ch/.test(content_type)],
  [
    'live_dvr',
    ({ content_type = '', is_live = false }) =>
      is_live && content_type === 'live_dvr',
  ],
  ['live', ({ is_live = false }) => is_live],
  ['vod', () => true],
];

function resolveConditions(obj, variants) {
  const [result] = variants.find(([, test]) => test(obj));
  return result;
}

// mggp-plugin-live-dvr modifies content_type in the stream, so we need always calculate it
export function getTypeOfContent(stream = {}) {
  return resolveConditions(stream, mappingStreamType);
}
